import { render, staticRenderFns } from "./designations.vue?vue&type=template&id=0c50a124&scoped=true"
import script from "./designations.vue?vue&type=script&lang=js"
export * from "./designations.vue?vue&type=script&lang=js"
import style0 from "./designations.vue?vue&type=style&index=0&id=0c50a124&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c50a124",
  null
  
)

export default component.exports